import React, { useState, useRef, useEffect } from 'react';

import Loader from '../reusables/Loader_TBD';
import { SVGIcon } from '../wrappers/SVGIcon';

import { Icons } from '../../data/Assets';

interface AudioPlayerProps {
    src: string;
};
const AudioPlayer = (props: AudioPlayerProps) => {
    const { src } = props;

    const audioRef = useRef<HTMLAudioElement>(null);

    const [isLoading, setIsLoading] = useState(false);
    const [isPlaying, setIsPlaying] = useState(false);
    const [duration, setDuration] = useState(0);
    const [currentTime, setCurrentTime] = useState(0);
    const [stepSize, setStepSize] = useState(0.01);

    const togglePlay = () => {
        if (!audioRef.current) return;

        if (isPlaying) {
            audioRef.current.pause();
        } else {
            audioRef.current.play();
        }

        setIsPlaying(!isPlaying);
    };

    const getDurationFromAudioUrl = async () => {
        const response = await fetch(src);
        const audioContext = new AudioContext();
        const audioBuffer = await audioContext.decodeAudioData(await response.arrayBuffer());

        const audioDuration = audioBuffer.duration;
        setDuration(audioDuration);
        setStepSize(audioDuration > 0 ? audioDuration / 100 : 0.01);
        setIsLoading(false);
    }

    const handleTimeUpdate = () => {
        if (!audioRef.current) return;

        setCurrentTime(audioRef.current.currentTime);

        const progress = (audioRef.current.currentTime / duration) * 100;
        const seekBar = document.querySelector<HTMLInputElement>(".immersion__audio_player__seek_bar");
        if (seekBar) {
            seekBar.style.background = `linear-gradient(to right, var(--immersion__colors__grey__700) ${progress}%, var(--immersion__colors__grey__50) ${progress}%)`;
        }
    };

    const handleSeek = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (!audioRef.current) return;
        audioRef.current.currentTime = parseFloat(e.target.value);

        setCurrentTime(audioRef.current.currentTime);
    };

    const formatTime = (time: number) => {
        const minutes = Math.floor(time / 60);
        const seconds = Math.floor(time % 60);
        return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
    };

    const handleEnded = () => {
        setCurrentTime(duration);
        setIsPlaying(false);
    }

    useEffect(() => {
        setIsLoading(true);
        getDurationFromAudioUrl();
    }, [src]); // eslint-disable-line

    return (
        <div className="immersion__audio_player">
            {isLoading
                ? <Loader text='Loading audio...' />
                : <React.Fragment>
                    <audio
                        ref={audioRef}
                        src={src}
                        onTimeUpdate={handleTimeUpdate}
                        onEnded={handleEnded}
                    />

                    <div className="immersion__audio_player__controls">
                        <input
                            type="range"
                            min={0}
                            max={duration}
                            value={currentTime}
                            step={stepSize}
                            onChange={handleSeek}
                            className="immersion__audio_player__seek_bar"
                        />

                        <div className="immersion__audio_player__time">
                            <span>{formatTime(0)}</span>
                            <span>{formatTime(duration)}</span>
                        </div>

                        <button onClick={togglePlay} className="immersion__audio_player__play_pause">
                            <SVGIcon src={isPlaying ? Icons.PauseCircle : Icons.PlayCircle} />
                        </button>

                        {/* <button className="immersion__audio_player__trash">
                <FaTrash />
            </button> */}
                    </div>
                </React.Fragment>
            }
        </div>
    );
};

export default AudioPlayer;